
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25 33.82a5 5 0 01-10.06 0M3.51 34v-6s3.74-1.56 4.57-10S13.21 5.06 20 5.06h0c6.83 0 11.12 4.52 12 12.91s4.57 10 4.57 10v6zM3.5 27.94h33M29.76 3.57c3.62 2.48 6.1 6.62 7.24 12.29M10.24 3.57C6.62 6.05 4.14 10.19 3 15.86","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M16.37 5.85V3.32c0-1.91 1.63-2.17 3.63-2.17s3.63.26 3.63 2.17v2.53","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    